module.exports = "/images/vendor/flag-icon-css/flags/4x3/vn.svg?6b3aef51e8b58cf029a85087e87591b5";